// Brevo API Service for VBC Website
const BREVO_API_KEY = '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';
const BREVO_API_URL = 'https://api.brevo.com/v3';

// List IDs for different contact types
const BREVO_LISTS = {
  FORM_SUBMISSION: null, // Will be set dynamically
  NEWSLETTER: null // Will be set dynamically
};

// Get all lists to find the correct IDs
const getBrevoLists = async () => {
  try {
    const response = await fetch(`${BREVO_API_URL}/contacts/lists`, {
      method: 'GET',
      headers: {
        'accept': 'application/json',
        'api-key': BREVO_API_KEY
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    // Find the list IDs by name
    if (data.lists) {
      data.lists.forEach(list => {
        if (list.name === 'VBC Form Submission') {
          BREVO_LISTS.FORM_SUBMISSION = list.id;
        } else if (list.name === 'VBC Newsletter sub') {
          BREVO_LISTS.NEWSLETTER = list.id;
        }
      });
    }
    
    console.log('Brevo Lists found:', BREVO_LISTS);
    return BREVO_LISTS;
  } catch (error) {
    console.error('Error fetching Brevo lists:', error);
    throw error;
  }
};

// Add contact to specific Brevo list
const addContactToBrevo = async (email, listType, additionalData = {}) => {
  try {
    // Ensure we have the list IDs
    if (!BREVO_LISTS.FORM_SUBMISSION || !BREVO_LISTS.NEWSLETTER) {
      await getBrevoLists();
    }

    const listId = listType === 'form' ? BREVO_LISTS.FORM_SUBMISSION : BREVO_LISTS.NEWSLETTER;
    
    if (!listId) {
      throw new Error(`List ID not found for type: ${listType}`);
    }

    const contactData = {
      email: email,
      listIds: [listId],
      attributes: {
        FIRSTNAME: additionalData.name || '',
        LASTNAME: '',
        COMPANY: additionalData.company || '',
        ...additionalData
      },
      updateEnabled: true // Update if contact already exists
    };

    const response = await fetch(`${BREVO_API_URL}/contacts`, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'content-type': 'application/json',
        'api-key': BREVO_API_KEY
      },
      body: JSON.stringify(contactData)
    });

    if (!response.ok) {
      // If contact already exists, that's okay
      if (response.status === 400) {
        const errorData = await response.json();
        if (errorData.message && errorData.message.includes('Contact already exist')) {
          console.log('Contact already exists in Brevo, updating...');
          return { success: true, message: 'Contact updated in Brevo' };
        }
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('Successfully added contact to Brevo:', result);
    return { success: true, data: result };
    
  } catch (error) {
    console.error('Error adding contact to Brevo:', error);
    throw error;
  }
};

// Add contact from form submission
export const addFormSubmissionToBrevo = async (email, name, company, interest, message) => {
  return addContactToBrevo(email, 'form', {
    name,
    company,
    INTEREST: interest,
    MESSAGE: message,
    SOURCE: 'VBC Website Form'
  });
};

// Add contact from newsletter subscription
export const addNewsletterSubscriptionToBrevo = async (email) => {
  return addContactToBrevo(email, 'newsletter', {
    SOURCE: 'VBC Website Newsletter'
  });
};

// Initialize the service by fetching list IDs
export const initializeBrevoService = async () => {
  try {
    await getBrevoLists();
    console.log('Brevo service initialized successfully');
    return true;
  } catch (error) {
    console.error('Failed to initialize Brevo service:', error);
    return false;
  }
};

export default {
  addFormSubmissionToBrevo,
  addNewsletterSubscriptionToBrevo,
  initializeBrevoService
};